import { createApiAction } from '@app/packages/api/utils'
import type { ApiSocialIdentity } from '@app/packages/api/v2/types/entities'

export const getIdentities = () =>
  createApiAction('getIdentities', dispatch => dispatch<{ data: ApiSocialIdentity[] }>({ method: 'GET', endpoint: '/api/v2/identities' }))
